import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Maximizestrategy() {
  return (
    <section
      className="maximize_strategy p-100"
      style={{ background: "#F5F7F5" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={9}
            className="m-auto text-center"
          >
            <h2>
              Maximize Your Revenue Potential With Our{" "}
              <span>Next-Generation</span> Telecom Software Solutions!
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <StaticImage
              src="../../images/services-usa/telecom-services/maximize-telecom.webp"
              alt="maximize-telecom"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1580}
              height={663}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Maximizestrategy;
